import React, {useRef} from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import {MSpinner, MScorecard} from "components/Shared";

const useStyles = makeStyles(({spacing}) => ({
  Root: {
    padding: spacing(1),
  },
  Item: ({ref : {current}}) => ({
    minWidth: current ? (
      current.clientWidth
    ) : (
      "unset"
    ),
  }),
}));

const MScorescreen =  ({scorecardData}) => {
  const ref = useRef(null);
  const classes = useStyles({ref});
  return scorecardData ? (
    <div className={classes.Root}>
      <Grid 
        container
        direction="row"
        spacing={1}
      >
        {scorecardData.data.map((metric, key) => 
          <Grid
            {...key === 0 ? {ref} : {}}
            key={key}
            item
            xs={2}
            className={classes.Item}
          >
            <MScorecard {...{metric}}/>
          </Grid>
        )}
      </Grid>
    </div>
  ) : (
    <MSpinner/>
  );
};

MScorescreen.propTypes = {
  scorecardData: PropTypes.object //Data from backend
};

export default MScorescreen;